<template>
  <div class="cart-popup__dialog">
    <TripleEyeHeader />

    <!-- //02_result -->
    <div class="cart-popup__content height-auto">
      <div class="content_eyecare">
        <div>
          <p class="eyecare_tit">
            <b class="color_orange">2. 나의 안구건조증 정도는?</b>
          </p>
          <p class="eyecare_txt2">12가지 질문에 대한 응답으로 확인된 안구건조증 결과를 확인해주세요.</p>

          <!-- 02_result-1 -->
          <template v-if="score < 10">
          <div class="txtC marB padT" ><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_01.png" alt="의사가 눈에 대해서 말하는 그림" style="max-width:320px;width:100%"></div>
          <p class="eyecare_result color_black">
            건강하게 관리되고 있습니다.<br>
            꾸준한 EPA DHA 섭취, 수분 보충, 적정 실내
            습도(60%) 및 온도(18℃) 유지를 통해
            앞으로도 건강하게 케어해주세요.
          </p>
          </template>

          <!-- 02_result-2 -->
          <template v-else-if="score < 20">
          <div class="txtC marB padT"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_02.png" alt="의사가 EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림" style="max-width:320px;width:100%"></div>
          <p class="eyecare_result color_black">
            눈의 건조감이 약하게 나타나고 있습니다.<br>
            EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.
          </p>
          </template>

          <!-- 02_result-3 -->
          <template v-else-if="score < 60">
          <div class="txtC marB padT"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_02.png" alt="의사가 EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림" style="max-width:320px;width:100%"></div>
          <p class="eyecare_result color_black">
            눈이 많이 건조한 편으로, 적극적인 케어가 필요합니다.<br>
            EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.
          </p>
          </template>

          <!-- 02_result-4 -->
          <template v-else-if="score >= 60">
          <div class="txtC marB padT"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_03.png" alt="의사가 병원 진료, EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림" style="max-width:320px;width:100%"></div>
          <p class="eyecare_result color_black">
            심한 건조감으로 병원 진료가 반드시 필요합니다.<br>
            더불어 EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.
          </p>
          </template>

        </div>
        <p style="color:#ccc;font-size:9px;text-align:right">CN001953</p>
      </div>
    </div>
    <div class="cart-popup__item-link">
      <button type="button" class="bt-akl-blue bt-eyecare-pop-sky" @click="$emit('clickResult')">이벤트 응모하기</button>
    </div>
    <!-- //02_result -->

  </div>
</template>

<script>
import TripleEyeHeader from './header.vue'

export default {
  name: 'TripleResult',
  components: {
    TripleEyeHeader
  },
  props: ['score', 'devMode']
}
</script>



// WEBPACK FOOTER //
// src/views/triple-eye-care/component/result.vue